var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 8h-8c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5zm-8-7c-.275 0-.5.224-.5.5v5c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-5c0-.276-.225-.5-.5-.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5zm-8-13c-.275 0-.5.224-.5.5v11c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-11c0-.276-.225-.5-.5-.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5zm-8-7c-.275 0-.5.224-.5.5v5c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-5c0-.276-.225-.5-.5-.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 14h-8c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5zm-8-13c-.275 0-.5.224-.5.5v11c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-11c0-.276-.225-.5-.5-.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4dfd917f.svg";
export { ForwardRef as ReactComponent };